// @flow

/**
 * Download Actions Context
 * Provides download action configuration to child components
 */

import { createContext } from 'react';
import type { DownloadAction } from '../types';

export const DownloadActionsContext = createContext<?DownloadAction[]>(null);
